import { get } from "lodash";
var FIRST_ERROR = "graphQLErrors[0].apiError.response.data.message";
export default (function (apollo, errorHandler) {
    if (!apollo.error) {
        return null;
    }
    var _a = apollo.error, graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
    if (graphQLErrors.length > 0) {
        return get(apollo.error, FIRST_ERROR);
    }
    if (networkError && "errorCode" in networkError && errorHandler) {
        var error = new Error();
        error.code = networkError.errorCode;
        try {
            errorHandler(error);
        }
        catch (e) {
            return e.message;
        }
    }
    if (networkError && "message" in networkError) {
        return networkError.message;
    }
    return apollo.error.message;
});
